import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !key) {
  throw new Error(
    'Missing Supabase env vars. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in .env',
  );
}

// Vite HMR re-evaluates this module on every save, which would normally call
// createClient() again — producing multiple GoTrueClient instances that fight
// over the shared navigator.locks lock and silently deadlock setSession /
// from() calls. Cache the client on globalThis so HMR reuses it.
const SINGLETON_KEY = Symbol.for('hermeneuticscommons.supabase');

// No-op lock: bypasses navigator.locks entirely so even when multiple
// GoTrueClient instances coexist (HMR, dev tools), they don't deadlock.
// We're single-user/single-tab, so serialisation isn't required.
const noLock = (_name, _acquireTimeout, fn) => fn();

const supabase =
  globalThis[SINGLETON_KEY] ??
  (globalThis[SINGLETON_KEY] = createClient(url, key, {
    auth: {
      persistSession: true,
      autoRefreshToken: false,
      detectSessionInUrl: false,
      flowType: 'implicit',
      storageKey: 'hc.auth',
      lock: noLock,
    },
  }));

export { supabase };
